import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Modal, Spin } from "antd";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { useDeleteGroupMutation } from "../../../redux/groups/groupsAPI";
import {
  updateOpenModalDelete,
  updateGroup,
  updateFormAction,
} from "../../../redux/groups/groupsSlice";
// COMPONENTS
import ModalDeleteItemContainer from "../../components/modal/ModalDeleteItemContainer";
import GlobalAlert2 from "../../home/GlobalAlert2";
// AUTHORIZATION
import GETJwtToken from "../../../redux/authentication/authentication";
// INTERFACES
import { RootState } from "../../../app/store";
import { FormAction } from "../../../types/enums";

function GroupDeleteModal() {
  // LOCAL STORAGE AND VARIABLES ******************** */
  const dispatch = useDispatch();

  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { group, openModalDelete } = useSelector((state: RootState) => state.group);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [triggerDeleteGroup, { isLoading, isSuccess, isError, error, reset: resetDeleteGroup }] =
    useDeleteGroupMutation();

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickClose = () => {
    dispatch(updateOpenModalDelete(false));
    dispatch(updateFormAction(FormAction.Create));
    dispatch(updateGroup({ name: "", messageTypeId: 0, organizationId: "" }));
  };

  const onClickDelete = async () => {
    const token = await GETJwtToken();
    triggerDeleteGroup({ id: group.id, token });
    dispatch(
      updateGroup({
        name: "",
        messageTypeId: 0,
        organizationId: "",
      }),
    );
  };

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    if (openModalDelete) {
      resetDeleteGroup();
    }
  }, [openModalDelete]);

  useEffect(() => {
    if (isSuccess || isError) {
      dispatch(updateOpenModalDelete(false));
    }
  }, [isSuccess, isError]);
  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Modal
      onOk={onClickClose}
      closable={false}
      onCancel={onClickClose}
      open={openModalDelete}
      footer={null}
    >
      <Spin spinning={isLoading}>
        <ModalDeleteItemContainer
          name={group.name}
          onClickDelete={onClickDelete}
          onClickClose={onClickClose}
        />
      </Spin>
      {/** ---------------------------------------------------- */}
      {/** GLOBAL ALERT */}
      <GlobalAlert2
        isError={isError}
        isSuccess={isSuccess}
        requestType="DELETE"
        error={error}
        name="Group"
      />
    </Modal>
  );
}

export default GroupDeleteModal;
